/* eslint-disable react/jsx-pascal-case */
import { message, Button, Col, ConfigProvider, Form, Tag, Row, Tabs, Space, Radio, Modal, Popconfirm, InputNumber, Switch, Spin } from "antd";
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { useOpneTime } from "../controller/OpenTimeController";
import dayjs from 'dayjs'

import axios from 'axios';
const OpenTime = ({

}) => {
    const [loading, setLoading] = useState(true)
    // 日期格式化函數
    const formatDate = (dateString, weekday) => {
        const date = dayjs(dateString)
        const year = date.format('YYYY')
        const month = date.format('MM')
        const day = date.format('DD')
        return `${year} 年 ${month} 月 ${day} 日 &nbsp;&nbsp; 星期${weekday}`;
    };

    const {
        OpneTimeData,
        getOpneTimeData,
        postOpneTimeData,
        patchOpneTimeData,
        deleteOpneTimeData,
    } = useOpneTime({
        onFinish: () => {
            setLoading(false)
        }
    })

    useEffect(() => {
        getOpneTimeData()
    }, [])

    // console.log('OpneTimeDatakk', OpneTimeData)

    return (
        <Spin spinning={loading}>
            <Row
                gutter={[24, 24]}
            >
                <Col span={24}>
                    <h2 style={{ fontWeight: 'bold' }} >◆ 今日開館時間 ◆</h2>
                </Col>
                {!loading && <>
                    <Col span={24} style={{ textAlign: 'center' }}>
                        <label style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: formatDate(OpneTimeData?.date, OpneTimeData?.weekday) }} />
                    </Col>
                    <Col span={24} style={{ textAlign: 'center' }}>
                        <label>今日開館時間：</label>
                        {OpneTimeData?.opentime_begin && (
                            <label style={{ color: 'blue', fontWeight: 'bold' }}>
                                {OpneTimeData.opentime_begin} ~ {OpneTimeData?.openime_end}
                            </label>
                        )}
                    </Col>
                    <Col span={24} style={{ textAlign: 'center' }}>
                        <a href="https://libdoc.pccu.edu.tw/calendar.html" style={{ color: 'blue', fontWeight: 'bold' }} >詳細開館情形</a>
                        、
                        <a href="https://lib.pccu.edu.tw/p/404-1012-76914.php?Lang=zh-tw" style={{ color: 'red', fontWeight: 'bold' }}>特殊開館時間</a>
                    </Col>
                </>}
            </Row>
        </Spin>

    );
}
export default OpenTime;
